import EnterpriseEpicClient from 'bundles/epic/clients/Enterprise';

// For some programs, we are running an AB test to determine if we should show skill pathways.
// If the current program is in the opt-in list, we will use the AB test to determine if we should show skill pathways.
// Otherwise, we will show skill pathways by default.
const shouldShowSkillPathways = (programId?: string) => {
  if (!programId) {
    return false;
  }

  const optInProgramList = EnterpriseEpicClient.get('verifiedSkillsAbTestProgramOptInList');

  if (optInProgramList.includes(programId)) {
    return EnterpriseEpicClient.get('verifiedSkillsAbTest');
  } else {
    return true;
  }
};

export default shouldShowSkillPathways;
